import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Btn } from './ui';

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-ink-50 dark:bg-ink-950 text-ink-800 dark:text-ink-100 flex flex-col items-center justify-center gap-4">
      <div className="text-[96px] font-black text-ink-200 dark:text-ink-800 leading-none">404</div>
      <h1 className="text-2xl font-extrabold">ページが見つかりません</h1>
      <p className="text-ink-500 dark:text-ink-400">
        お探しのページは存在しないか、削除された可能性があります。
      </p>
      <Btn variant="outline" size="md" onClick={() => navigate('/')}>
        トップへ戻る
      </Btn>
    </div>
  );
};

export default NotFound;